import React, { useEffect, useState } from 'react';
import { Button, Chip, IconButton, Typography, useMediaQuery } from '@mui/material';
import { AddShoppingCart} from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';

import styled from "styled-components";
import { Image } from 'cloudinary-react'

import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../../../../features/slices/cartSlice';
import { addToFavorite, removeFromFavorite } from '../../../../features/slices/favoriteSlice';
import { useDeleteChargerMutation, useGetCartQuery, useGetUserFavoritesQuery, useUpdateCartMutation, useUpdateFavoriteMutation, useUpdateChargerMutation} from '../../../../features/fullApi'
import ReactGA from "react-ga4";

import ConfirmDialog from '../../../Modals/ConfirmDialog';
import ConfirmStatusDialog from '../../../Modals/ConfirmStatusDialog';

import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import FavoriteIcon from '@mui/icons-material/Favorite';

import toast from 'react-hot-toast';


import { useTheme } from '@mui/material/styles';

import { makeStyles } from '@mui/styles';


const useStyles = makeStyles({
  addToCartBtn: {
  },
});

const Info = styled.div`
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease;
  cursor: pointer;
`;

const Container = styled.div`
  flex: 1;
  margin: 5px;
  width: 200px;
  height: 450px;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  align-items: center;
  border:1px solid #ededed;
  justify-content: center;
  position: relative;
`;

const MobileContainer = styled.div`
  border-radius: 10px;
  maxHeight: 350px;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: 1px solid #ddd;
  margin: 0 10px;
  position: relative;
`;

const TabletContainer = styled.div`
  display: flex;
  flex: 1;
  margin: 5px;
  width: 450px;
  height: 250px;
  align-items: center;
  justify-content: center;
  background-color: #f5fbfd;
  position: relative;s23
  &:hover ${Info}{
    opacity: 1;
  }
`;

const Icon = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  transition: all 0.5s ease;
  &:hover {
    background-color: #e9f5f5;
    transform: scale(1.1);
    cursor:pointer;
  }
`;

const Chargers = ({ charger }) => {
  const navigate = useNavigate()

  console.log("PRODUCT###", charger)

  const user = JSON.parse(localStorage.getItem('user'))
  const dispatch = useDispatch()

  const [updateCart] = useUpdateCartMutation()
  const [deleteChargers] = useDeleteChargerMutation()

  const {data: cart, error: cartError, isLoading: cartIsLoading} = useGetCartQuery(user?._id);

  const [open, setOpen] = useState(false)

  const cartLs = useSelector(state => state.cart)
  const favoriteLs = useSelector(state => state.favorite)
  const theme = useTheme()

  const [openStatus, setOpenStatus] = useState(false)

  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));

  const {data: favorite, error: favoriteError, isLoading: favoriteIsLoading} = useGetUserFavoritesQuery(user?._id);
  const [updateFavorite] = useUpdateFavoriteMutation()

  const [remove, setRemove] = useState(false)
  const [red, setRed] = useState(false)
  const [checked, setChecked] = useState(false)

  const fav = JSON.parse(localStorage.getItem("favoriteItems"))
  const currentFavChargers = JSON.parse(localStorage.getItem("favoriteItems"))

  useEffect(() => {
      currentFavChargers?.map(favoriteProd => {
        if(favoriteProd._id === charger._id) {
          setRed(true)
        }
    })
    setChecked(true)
  }, [])
  


  const handleAddToFavorites = async (chargerz) => {
    if(user?.accessToken && favorite?._id) {
      let found = false
        let newChargers = []
        const currentChargers = JSON.parse(localStorage.getItem("favoriteItems"))
        currentChargers?.map(async charger => {
          if(charger._id === chargerz._id) {
            dispatch(removeFromFavorite(chargerz))
            found = true
          } else {
            newChargers.push({productId: charger._id})
          }
        })
        
        if(found) {
          setRed(false)
        } else{
          setRed(true)
          dispatch(addToFavorite(chargerz))
          newChargers.push({productId: chargerz._id})
        }

        updateFavorite({_id: favorite._id, products: newChargers}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        })
        .then(res => {
          console.log("res.data", res.data)
          if(!found) {
            toast.success('Charger added to favorites')
          } else {
            toast('Charger removed from favorites', {
              icon: '❌',
            });
          }
         
        })
        .catch(err => console.log("err", err))   
    } else {
      toast.error("Please log in or register", {
        position: "bottom-left",
    })
    }
  }

  const handleAddToCart = (product) => {
    if(user?.accessToken && cart?._id) {
      ReactGA.event({
        category: "chargers",
        action: "add to cart",
        label: product.title, 
      });
      let cartProduct = cartLs.cartItems.filter(function (el)
      {
        return el._id === product._id
      })

      if(cartProduct.length === 0) {
        let newProducts = []
        dispatch(addToCart(product))
        const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
        currentProducts.map(product => {
          newProducts.push({productId: product._id, quantity: product.cartQuantity})
        })
        console.log("Cart id", cart._id)
        console.log('products are', newProducts)
        updateCart({_id: cart._id, products: newProducts}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        })
        .then(res => {
          console.log("res.data", res.data)
          toast.success('Product added to cart')
        })
        .catch(err => console.log("err", err))
      } else if(cartProduct[0].cartQuantity < product.quantity) {
        let newProducts = []
        dispatch(addToCart(product))
        const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
        currentProducts.map(product => {
          newProducts.push({productId: product._id, quantity: product.cartQuantity})
        })
        console.log("Cart id", cart._id)
        updateCart({_id: cart._id, products: newProducts}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        })
        .then(res => toast.success('Product added to cart'))
        .catch(err => console.log("err", err))
      } else {
        toast("You hitted our max stock for this product")
      }
    } else {
      toast.error("Please log in or register", {
        position: "bottom-left",
    })
    }
  }

  const openDeleteModal = ((chargerId) => {
    setOpen(true)
  })

  const handleDelete = ((chargerId) => {
    setOpen(false)
    console.log("charger id is", chargerId)
    deleteChargers({id: chargerId}, { 
      headers: {
        'Token': `Bearer ${user?.accessToken}`
      }
    })
    toast.success("Chargers successfully deleted")
  })

  const [updateCharger] = useUpdateChargerMutation()
  const handleToggleStatus = ((charger) => {
    console.log("charger SENT IS", charger)
    setOpenStatus(false);
    updateCharger({_id: charger._id, isActive: !charger.isActive}, { 
      headers: {
        'Token': `Bearer ${charger?.accessToken}`
      }
    }).then(res =>
        {
            if(res.data.isActive) {
              toast(`🟢 ${charger.title} sent to shop`)
            } else {
              toast(`🚫 ${charger.title} retreated from shop`)
            }
           
        }
    )
  })
  const openToggleStatusModal = (() => {
    console.log("charger data", charger)
    if(charger.quantity > 0 && charger.price !== 0) {
        setOpenStatus(true)
    } else {
        if(charger.isActive) {
          setOpenStatus(true)
        }
        toast("⚠️ You must set price and quantity in order to toggle status")
    }
  
  })

  const classes = useStyles();
  const message = "Are you sure you want to delete this charger ?";

  const renderMobileChargers = () => (
    <MobileContainer>
    {cartIsLoading && !user && !cartError ? (
          <></>
      ) :
      <div>
          <div style={{position:'absolute', right:'2px', top:'0px', backgroundColor:'transparent'}}>
          <Icon color={red ? "primary" : "#ddd"} style={{width:'40px', height:'40px',backgroundColor:'#efefef'}} onClick={() => handleAddToFavorites(charger)}aria-label="Edit charger">
            {red ? <FavoriteIcon color="primary"/> : <FavoriteBorderIcon/>}
          </Icon>
          </div>
          <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
            <Image cloudName="deqqgmfxk"  publicId={charger.img} style={{width: '140px', height: '140px', objectFit:'cover', objectPosition:'center', marginBottom: '15px'}}  onClick={() => navigate(`/charger/${charger._id}`)}/>
          </div>
          <div style={{display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
            <Typography  onClick={() => navigate(`/charger/${charger._id}`)} gutterBottom variant="subtitle1" component="h6" style={{textAlign: 'center'}}>
                {charger.title}
            </Typography>
            <Typography  onClick={() => navigate(`/charger/${charger._id}`)} gutterBottom variant="subtitle1" component="h6">
                ${charger.price}
            </Typography>
            {(charger.quantity <= 5 && charger.quantity >=1) && <Chip style={{color: '#fff', backgroundColor: 'red', marginBottom: '5px'}} label={`${charger.quantity} left`} />}
            {(charger.quantity > 5) && <Chip style={{color: '#fff', backgroundColor: 'green', marginBottom: '5px'}} label={`5+ stock`} />}
            {(charger.quantity === 0) && <Chip style={{color: '#fff', backgroundColor: '#eee', marginBottom: '5px'}} label={`0 left`} />}
            <Button disabled={charger.quantity === 0} className={classes.addToCartBtn}  variant="contained" size="small" style={{width: '125px'}}  onClick={() => handleAddToCart(charger)}>{charger.quantity > 0 ? "Add to cart" : "Out of stock"}</Button>
            {user?.isAdmin &&
            <div style={{display: 'flex', justifyContent:'center', alignItems:'center', width:'50px'}}>
             <Icon fontSize="small" aria-label="Edit charger" onClick={() => navigate(`/charger/edit/${charger._id}`)}>
                <EditIcon/>
              </Icon>
              <Icon aria-label="Delete charger" fontSize="small"  onClick={() => openDeleteModal()}>
                <DeleteIcon style={{color: 'red'}}/>
              </Icon>
              <Icon fontSize="small"  aria-label="Change Status" onClick={() => openToggleStatusModal(charger._id)} size="small">
                  {charger.isActive ?  <ToggleOnIcon style={{color: 'green'}}/> : <ToggleOffIcon style={{color: 'red'}}></ToggleOffIcon>}  
              </Icon>
              <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={charger} message={message}></ConfirmDialog>
              <ConfirmStatusDialog openStatus={openStatus} handleToggleStatus={handleToggleStatus} setOpenStatus={setOpenStatus} item={charger}></ConfirmStatusDialog>
            </div>
          }
        </div>
      </div>
  }
    </MobileContainer>
  )


  const renderTabletChargers = () => (
    <TabletContainer>
    {cartIsLoading && !user && !cartError ? (
          <></>
      ) :
      <>
        <div style={{position:'absolute', right:'2px', top:'0px', backgroundColor:'transparent'}}>
        <Icon color={red ? "primary" : "#000"} style={{width:'40px', height:'40px',backgroundColor:'#efefef'}} onClick={() => handleAddToFavorites(charger)}aria-label="Edit charger">
          {red ? <FavoriteIcon color="primary"/> : <FavoriteBorderIcon/>}
        </Icon>
        </div>
        <Image cloudName="deqqgmfxk"  publicId={charger.img} style={{width: '250px', height: '250px', objectFit:'cover', objectPosition:'center'}}/>
        <div style={{display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center', padding: '10px', width: '200px'}} onClick={() => navigate(`/charger/${charger._id}`)}>
        <Typography gutterBottom variant="h5" component="h2" style={{textAlign: 'center'}}>
            {charger.title}
        </Typography>
        <Typography gutterBottom variant="h5" component="h2">
            ${charger.price}
        </Typography>
        {(charger.quantity <= 5 && charger.quantity >=1) && <Chip style={{color: '#fff', backgroundColor: 'red', marginBottom: '5px'}} label={`${charger.quantity} left`} />}
        {(charger.quantity > 5) && <Chip style={{color: '#fff', backgroundColor: 'green', marginBottom: '5px'}} label={`5+ stock`} />}
        {(charger.quantity === 0) && <Chip style={{color: '#fff', backgroundColor: '#eee', marginBottom: '5px'}} label={`0 left`} />}
        <Button  disabled={charger.quantity === 0} className={classes.addToCartBtn}  variant="contained" size="small" style={{width: '125px'}}  onClick={() => handleAddToCart(charger)}>{charger.quantity > 0 ? "Add to cart" : "Out of stock"}</Button>
        </div>
      <Info>
        <IconButton disabled={charger.quantity === 0} aria-label="Add to Cart" onClick={() => 
        {
          handleAddToCart(charger);
        }}>
          <AddShoppingCart/>
        </IconButton>
        {user?.isAdmin && 
            <>
             <Icon aria-label="Edit charger" onClick={() => navigate(`/charger/edit/${charger._id}`)}>
                <EditIcon/>
              </Icon>
              <Icon aria-label="Delete charger" onClick={() => openDeleteModal()}>
                <DeleteIcon style={{color: 'red'}}/>
              </Icon>
              <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={charger} message={message}></ConfirmDialog>
            </>
        }

        <Icon aria-label="View charger" onClick={() => navigate(`/charger/${charger._id}`)}>
          <RemoveRedEyeIcon/>
        </Icon>
      </Info>
      </>
  }
    </TabletContainer>
  )

  const [title, setTitle] = useState(charger.title)


  const renderDesktopChargers = () => (
    <Container sx={{padding: '10px', borderRadius: '10px'}}>
    {cartIsLoading && !user && !cartError && title && favoriteIsLoading && checked ? (
          <></>
      ) :
      <>
      <div style={{position:'absolute', right:'2px', top:'0px', backgroundColor:'transparent'}}>
      <Icon color={red ? "primary" : "#000"} style={{width:'40px', height:'40px',backgroundColor:'#efefef'}} onClick={() => handleAddToFavorites(charger)}aria-label="Edit charger">
        {red ? <FavoriteIcon color="primary"/> : <FavoriteBorderIcon/>}
      </Icon>
      </div>
      <div id="prodHover" className="chargerCard" onClick={() => navigate(`/charger/${charger._id}`)}>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Image cloudName="deqqgmfxk"  publicId={charger.img} style={{width: '175px', borderRadius: '10px', textAlign: 'center', height: '175px', objectFit:'cover', objectPosition:'center', margin: '0 auto'}}/>
        </div>
        
          <Typography gutterBottom variant="subtitle1" component="h6">
              {title?.substring(0, 30) + "..."}
          </Typography>
          <Typography gutterBottom variant="subtitle1" component="h6">
              ${charger.price}
          </Typography>
          {(charger.quantity <= 5 && charger.quantity >=1) && <Chip style={{color: '#fff', backgroundColor: 'red', marginBottom: '5px'}} label={`${charger.quantity} left`} />}
          {(charger.quantity > 5) && <Chip style={{color: '#fff', backgroundColor: 'green', marginBottom: '5px'}} label={`5+ stock`} />}
          {(charger.quantity === 0) && <Chip style={{color: '#fff', backgroundColor: '#eee', marginBottom: '5px'}} label={`0 left`} />}
      </div>

      <Button disabled={charger.quantity === 0} className={classes.addToCartBtn}   variant="contained" size="small" style={{width: '125px', marginTop:'25px'}}  onClick={() => handleAddToCart(charger)}>{charger.quantity > 0 ? "Add to cart" : "Out of stock"}</Button>
      {user?.isAdmin && 
            <div style={{display:'flex', justifyContent:'space-between', alignItems:"center"}}>
             <Icon aria-label="Edit charger" onClick={() => navigate(`/charger/edit/${charger._id}`)}>
                <EditIcon/>
              </Icon>
              <Icon aria-label="Delete charger" onClick={() => openDeleteModal()}>
                <DeleteIcon style={{color: 'red'}}/>
              </Icon>
              <Button aria-label="Change Status" className="addToCartBtn" onClick={() => openToggleStatusModal(charger._id)} size="small">
                  {charger.isActive ?  <ToggleOnIcon style={{color: 'green'}}/> : <ToggleOffIcon style={{color: 'red'}}></ToggleOffIcon>}  
              </Button>
              <ConfirmStatusDialog openStatus={openStatus} handleToggleStatus={handleToggleStatus} setOpenStatus={setOpenStatus} item={charger}></ConfirmStatusDialog>
              <ConfirmDialog open={open} handleDelete={handleDelete} setOpen={setOpen} item={charger} message={message}></ConfirmDialog>
            </div>
        }
      </>
  }
    </Container>
  )

  return (
    <div className="chargerClick">
        {
        (isXs) ?  renderMobileChargers() : 
        (isSm) ? renderMobileChargers() :
        (isMd) ? renderTabletChargers() :
        renderDesktopChargers()
      }
    </div>
  );
};

// const Chargers = connectHitInsights(aa)(ChargersCard)
export default Chargers;